import React, { useEffect, Suspense, lazy, createElement } from 'react';
import { UrgencyBar } from './components/UrgencyBar';
import { HeroSection } from './components/HeroSection';
// Lazy load below-the-fold sections
const PainSection = lazy(() => import('./components/PainSection').then(m => ({
  default: m.PainSection
})));
const SolutionSection = lazy(() => import('./components/SolutionSection').then(m => ({
  default: m.SolutionSection
})));
const ProductContent = lazy(() => import('./components/ProductContent').then(m => ({
  default: m.ProductContent
})));
const BonusSection = lazy(() => import('./components/BonusSection').then(m => ({
  default: m.BonusSection
})));
const PricingSelector = lazy(() => import('./components/PricingSelector').then(m => ({
  default: m.PricingSelector
})));
const GuaranteeSection = lazy(() => import('./components/GuaranteeSection').then(m => ({
  default: m.GuaranteeSection
})));
const FAQSection = lazy(() => import('./components/FAQSection').then(m => ({
  default: m.FAQSection
})));
const FinalCTA = lazy(() => import('./components/FinalCTA').then(m => ({
  default: m.FinalCTA
})));
const TestimonialsSection = lazy(() => import('./components/TestimonialsSection').then(m => ({
  default: m.TestimonialsSection
})));
const FooterSection = lazy(() => import('./components/FooterSection').then(m => ({
  default: m.FooterSection
})));
const SocialProofPopup = lazy(() => import('./components/SocialProofPopup').then(m => ({
  default: m.SocialProofPopup
})));
declare global {
  interface Window {
    fbq: any;
    _fbq: any;
  }
}
const META_PIXEL_ID = '1927478928649366';
const LCP_IMAGE = 'https://cdn.magicpatterns.com/uploads/4fA3L9gwwrqypbCgeT2b5A/heylloyd-image-1773680555106.png';
export function App() {
  useEffect(() => {
    // Add preconnect hints for critical origins
    const preconnects = ['https://cdn.magicpatterns.com'];
    preconnects.forEach(origin => {
      if (!document.querySelector(`link[rel="preconnect"][href="${origin}"]`)) {
        const link = document.createElement('link');
        link.rel = 'preconnect';
        link.href = origin;
        link.crossOrigin = 'anonymous';
        document.head.insertBefore(link, document.head.firstChild);
      }
    });
    // Preload LCP image
    if (!document.querySelector(`link[href="${LCP_IMAGE}"]`)) {
      const link = document.createElement('link');
      link.rel = 'preload';
      link.as = 'image';
      link.href = LCP_IMAGE;
      link.setAttribute('fetchpriority', 'high');
      document.head.appendChild(link);
    }
    const deferPixel = () => {
      if (window.fbq) return;
      const n: any = window.fbq = function (...args: any[]) {
        n.callMethod ? n.callMethod.apply(n, args) : n.queue.push(args);
      };
      if (!window._fbq) window._fbq = n;
      n.push = n;
      n.loaded = true;
      n.version = '2.0';
      n.queue = [];
      if (!document.querySelector(`script[src*="fbevents.js"]`)) {
        const t = document.createElement('script');
        t.async = true;
        t.setAttribute('fetchpriority', 'low');
        t.src = 'https://connect.facebook.net/en_US/fbevents.js';
        document.head.appendChild(t);
      }
      window.fbq('init', META_PIXEL_ID);
      window.fbq('track', 'PageView');
    };
    // Delay pixel load 3.5s to avoid blocking main thread during initial render
    const timerId = setTimeout(() => {
      if ('requestIdleCallback' in window) {
        ;
        (window as any).requestIdleCallback(deferPixel);
      } else {
        deferPixel();
      }
    }, 3500);
    return () => clearTimeout(timerId);
  }, []);
  return <div className="min-h-screen bg-deep-black text-smoke font-body selection:bg-electric-blue/30 selection:text-white" data-id="element-0">
      <UrgencyBar data-id="element-1" />

      <main className="pt-14 md:pt-[52px]" data-id="element-2">
        {' '}
        {/* Offset for fixed UrgencyBar */}
        <HeroSection data-id="element-3" />
        <Suspense fallback={null} data-id="element-4">
          <PainSection data-id="element-5" />
          <SolutionSection data-id="element-6" />
          <ProductContent data-id="element-7" />
          <BonusSection data-id="element-8" />
          <PricingSelector data-id="element-9" />
          <GuaranteeSection data-id="element-10" />
          <FAQSection data-id="element-11" />
          <FinalCTA data-id="element-12" />
          <TestimonialsSection data-id="element-13" />
        </Suspense>
      </main>

      <Suspense fallback={null} data-id="element-14">
        <FooterSection data-id="element-15" />
        <SocialProofPopup data-id="element-16" />
      </Suspense>
    </div>;
}